import { distance, piMod } from './util';
import ellipse from './ellipse';
// åå¯¼æ° x
function derivativeXAt(cx, cy, rx, ry, xRotation, startAngle, endAngle, angle) {
    return -1 * rx * Math.cos(xRotation) * Math.sin(angle) - ry * Math.sin(xRotation) * Math.cos(angle);
}
// åå¯¼æ° y
function derivativeYAt(cx, cy, rx, ry, xRotation, startAngle, endAngle, angle) {
    return -1 * rx * Math.sin(xRotation) * Math.sin(angle) + ry * Math.cos(xRotation) * Math.cos(angle);
}
// x çæå¼
function xExtrema(rx, ry, xRotation) {
    return Math.atan((-ry / rx) * Math.tan(xRotation));
}
// y çæå¼
function yExtrema(rx, ry, xRotation) {
    return Math.atan(ry / (rx * Math.tan(xRotation)));
}
// æ ¹æ®è§åº¦æ± x åæ 
function xAt(cx, cy, rx, ry, xRotation, angle) {
    return rx * Math.cos(xRotation) * Math.cos(angle) - ry * Math.sin(xRotation) * Math.sin(angle) + cx;
}
// æ ¹æ®è§åº¦æ± y åæ 
function yAt(cx, cy, rx, ry, xRotation, angle) {
    return rx * Math.sin(xRotation) * Math.cos(angle) + ry * Math.cos(xRotation) * Math.sin(angle) + cy;
}
// è·åç¹å¨æ¤­åä¸çè§åº¦
function getAngle(rx, ry, x0, y0) {
    var angle = Math.atan2(y0 * rx, x0 * ry);
    // è½¬æ¢å° 0 - 2PI å
    return (angle + Math.PI * 2) % (Math.PI * 2);
}
// æ ¹æ®è§åº¦è·åï¼x,y
function getPoint(rx, ry, angle) {
    return {
        x: rx * Math.cos(angle),
        y: ry * Math.sin(angle),
    };
}
// æè½¬
function rotate(x, y, angle) {
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    return [x * cos - y * sin, x * sin + y * cos];
}
export default {
    /**
     * è®¡ç®åå´ç
     * @param {number} cx         åå¿ x
     * @param {number} cy         åå¿ y
     * @param {number} rx         x è½´æ¹åçåå¾
     * @param {number} ry         y è½´æ¹åçåå¾
     * @param {number} xRotation  æè½¬è§åº¦
     * @param {number} startAngle èµ·å§è§åº¦
     * @param {number} endAngle   ç»æè§åº¦
     * @return {object} åå´çå¯¹è±¡
     */
    box: function (cx, cy, rx, ry, xRotation, startAngle, endAngle) {
        var xDim = xExtrema(rx, ry, xRotation);
        var minX = Infinity;
        var maxX = -Infinity;
        var xs = [startAngle, endAngle];
        for (var i = -Math.PI * 2; i <= Math.PI * 2; i += Math.PI) {
            var xAngle = xDim + i;
            if (startAngle < endAngle) {
                if (startAngle < xAngle && xAngle < endAngle) {
                    xs.push(xAngle);
                }
            }
            else {
                if (endAngle < xAngle && xAngle < startAngle) {
                    xs.push(xAngle);
                }
            }
        }
        for (var i = 0; i < xs.length; i++) {
            var x = xAt(cx, cy, rx, ry, xRotation, xs[i]);
            if (x < minX) {
                minX = x;
            }
            if (x > maxX) {
                maxX = x;
            }
        }
        var yDim = yExtrema(rx, ry, xRotation);
        var minY = Infinity;
        var maxY = -Infinity;
        var ys = [startAngle, endAngle];
        for (var i = -Math.PI * 2; i <= Math.PI * 2; i += Math.PI) {
            var yAngle = yDim + i;
            if (startAngle < endAngle) {
                if (startAngle < yAngle && yAngle < endAngle) {
                    ys.push(yAngle);
                }
            }
            else {
                if (endAngle < yAngle && yAngle < startAngle) {
                    ys.push(yAngle);
                }
            }
        }
        for (var i = 0; i < ys.length; i++) {
            var y = yAt(cx, cy, rx, ry, xRotation, ys[i]);
            if (y < minY) {
                minY = y;
            }
            if (y > maxY) {
                maxY = y;
            }
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY,
        };
    },
    /**
     * è·ååå¼§çé¿åº¦ï¼è®¡ç®åå¼§é¿åº¦æ¶ä¸èèæè½¬è§åº¦ï¼
     * ä»è· rx, ry, startAngle, endAngle ç¸å³
     * @param {number} cx         åå¿ x
     * @param {number} cy         åå¿ y
     * @param {number} rx         x è½´æ¹åçåå¾
     * @param {number} ry         y è½´æ¹åçåå¾
     * @param {number} xRotation  æè½¬è§åº¦
     * @param {number} startAngle èµ·å§è§åº¦
     * @param {number} endAngle   ç»æè§åº¦
     */
    length: function (cx, cy, rx, ry, xRotation, startAngle, endAngle) { },
    /**
     * è·åæå®ç¹å°åå¼§çæè¿è·ç¦»çç¹
     * @param {number} cx         åå¿ x
     * @param {number} cy         åå¿ y
     * @param {number} rx         x è½´æ¹åçåå¾
     * @param {number} ry         y è½´æ¹åçåå¾
     * @param {number} xRotation  æè½¬è§åº¦
     * @param {number} startAngle èµ·å§è§åº¦
     * @param {number} endAngle   ç»æè§åº¦
     * @param {number} x0         æå®ç¹ç x
     * @param {number} y0         æå®ç¹ç y
     * @return {object} å°æå®ç¹æè¿è·ç¦»çç¹
     */
    nearestPoint: function (cx, cy, rx, ry, xRotation, startAngle, endAngle, x0, y0) {
        // å°æè¿è·ç¦»é®é¢è½¬æ¢æå°æ¤­åä¸­å¿ 0,0 æ²¡ææè½¬çæ¤­åé®é¢
        var relativeVector = rotate(x0 - cx, y0 - cy, -xRotation);
        var x1 = relativeVector[0], y1 = relativeVector[1];
        // è®¡ç®ç¹å°æ¤­åçæè¿çç¹
        var relativePoint = ellipse.nearestPoint(0, 0, rx, ry, x1, y1);
        // è·åç¹å¨æ¤­åä¸çè§åº¦
        var angle = getAngle(rx, ry, relativePoint.x, relativePoint.y);
        // ç¹æ²¡æå¨åå¼§ä¸
        if (angle < startAngle) {
            // å°äºèµ·å§åå¼§
            relativePoint = getPoint(rx, ry, startAngle);
        }
        else if (angle > endAngle) {
            // å¤§äºç»æåå¼§
            relativePoint = getPoint(rx, ry, endAngle);
        }
        // æè½¬å° xRotation çè§åº¦
        var vector = rotate(relativePoint.x, relativePoint.y, xRotation);
        return {
            x: vector[0] + cx,
            y: vector[1] + cy,
        };
    },
    pointDistance: function (cx, cy, rx, ry, xRotation, startAngle, endAngle, x0, y0) {
        var nearestPoint = this.nearestPoint(cx, cy, rx, ry, x0, y0);
        return distance(nearestPoint.x, nearestPoint.y, x0, y0);
    },
    pointAt: function (cx, cy, rx, ry, xRotation, startAngle, endAngle, t) {
        var angle = (endAngle - startAngle) * t + startAngle;
        return {
            x: xAt(cx, cy, rx, ry, xRotation, angle),
            y: yAt(cx, cy, rx, ry, xRotation, angle),
        };
    },
    tangentAngle: function (cx, cy, rx, ry, xRotation, startAngle, endAngle, t) {
        var angle = (endAngle - startAngle) * t + startAngle;
        var dx = derivativeXAt(cx, cy, rx, ry, xRotation, startAngle, endAngle, angle);
        var dy = derivativeYAt(cx, cy, rx, ry, xRotation, startAngle, endAngle, angle);
        return piMod(Math.atan2(dy, dx));
    },
};
//# sourceMappingURL=arc.js.map